/* eslint-disable max-len */
/* eslint-disable import/prefer-default-export */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import defaultPhoto from 'assets/img/image-placeholder.jpg';
import Img from 'modules/common/components/Img';

function Requirements({ data }) {
  const tabList = data || [];
  const [requirementTab, setRequirementTab] = useState(0);
  const activeRequirement = _.get(tabList, requirementTab, {});
  const activeUrl = _.get(activeRequirement, 'attributes.url', '');

  const handleChangeRequirementTab = (location) => () => {
    setRequirementTab(location);
  };

  const renderRequirementList = () => (
    <div className="form-wrapper arrow-card">
      {!_.isEmpty(tabList) &&
        tabList.map((item, i) => (
          <div
            key={item.id || `req-${i}`}
            role="presentation"
            className="arrow-cell p-3 btn-blank"
            onClick={handleChangeRequirementTab(i)}
            style={{
              cursor: 'pointer',
              backgroundColor: i === requirementTab ? '#f8f9fa' : 'transparent',
            }}
          >
            <div className="font-weight-bold">{_.get(item, 'attributes.name')}</div>
            {i === requirementTab ? <div className="arrow" /> : ''}
          </div>
        ))}
    </div>
  );

  const renderPreview = () => {
    const isPdf = /\.pdf$/i.test(activeUrl);

    return (
      <div
        className="form-wrapper preview-image"
        style={{ overflow: 'hidden' }}
      >
        {isPdf ? (
          <iframe
            title="Cedula requirements"
            style={{ width: '100%', height: '400px' }}
            className="img img-fluid"
            src={activeUrl}
          />
        ) : (
          <Img
            src={activeUrl}
            className="shadow-sm rounded my-3"
            role="presentation"
            defaultSrc={defaultPhoto}
            width="100%"
            style={{
              maxWidth: '95%',
              maxHeight: '500px',
              objectFit: 'contain',
              display: 'block',
              margin: '0 auto',
            }}
            alt=""
          />
        )}
      </div>
    );
  };

  return (
    <div className="m-3">
      <div className="row mb-3">
        <div className="col-6">{renderRequirementList()}</div>
        <div className="col-6">{renderPreview()}</div>
      </div>
    </div>
  );
}

Requirements.propTypes = {
  data: PropTypes.arrayOf(PropTypes.instanceOf(Object)).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withRouter,
  connect(
    mapStateToProps
  ),
]);


export default enhance(Requirements);
